import { render, staticRenderFns } from "./storeroomAccount.vue?vue&type=template&id=3c493f35&scoped=true&"
import script from "./storeroomAccount.vue?vue&type=script&lang=js&"
export * from "./storeroomAccount.vue?vue&type=script&lang=js&"
import style0 from "./storeroomAccount.vue?vue&type=style&index=0&id=3c493f35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c493f35",
  null
  
)

export default component.exports